<footer class="footer" [class.light]="isLight" on>
    <hr class="footer-hr" *ngIf="!isLight" />
    <div class="footer-links">
        <p class="small">
            <span>&copy; {{ currentYear }} - Neptune Retail Solutions. All rights reserved.</span>
            |<a target="_blank" href="https://neptuneretailsolutions.com/website/privacypolicy.pdf"
                >Privacy Policy</a
            >
            |<a target="_blank" href="https://neptuneretailsolutions.com/contact-us/">Contact Us</a>
            <span *ngIf="!isLight"> | v{{ version }} </span>
        </p>
    </div>
</footer>
